var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.$t('field.settings.language'))+"\n  ")]),_vm._v(" "),_c('v-card-text',[_c('v-select',{staticClass:"mt-0 pt-0",attrs:{"items":_vm.LanguageEnum,"hide-details":"","solo":""},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }